import { combineReducers } from 'redux'

import { RECEIVE_GROUP_MEMBERSHIPS } from '../actions/membership-actions'

const forGroup = (state = [], action) => {
  switch(action.type) {
    case RECEIVE_GROUP_MEMBERSHIPS: return action.memberships
    default: return state
  }
}

export default combineReducers({
  forGroup
})
